import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Form, Page, Text, Button } from '@fielded/shared-ui'
import { Arrow } from '@fielded/shared-ui/src/icons'

import EntryViewWrapper from '../common/EntryViewWrapper'

class OTPVerification extends Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    maskedContact: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onResendOTP: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    inProcess: PropTypes.bool,
    error: PropTypes.string,
    resendTimer: PropTypes.number
  }

  static defaultProps = {
    inProcess: false,
    error: null,
    resendTimer: 0
  }

  handleFormSubmit = (fields) => {
    if (fields.otpCode && fields.otpCode.length === 6) {
      this.props.onSubmit(fields)
    }
  }

  render () {
    const {
      config,
      maskedContact,
      inProcess,
      error,
      resendTimer,
      onResendOTP,
      onBack
    } = this.props

    return (
      <EntryViewWrapper config={config}>
        <Page.Panel.Section>
          <div className='login__panel-title'>
            Enter the code
          </div>
        </Page.Panel.Section>

        <Page.Panel.Section>
          <Text>
            We sent a 6-digit code to {maskedContact}. <br />
            Type the code below.
          </Text>
        </Page.Panel.Section>

        {error && (
          <Page.Panel.Message type='danger' cta={false}>
            {error}
          </Page.Panel.Message>
        )}

        <Page.Panel.Section>
          <Form
            onSubmit={this.handleFormSubmit}
            component='form'
          >
            <Form.Row>
              <Form.Field
                fieldName='otpCode'
                labelText=''
              >
                <Form.Field.OTPInput
                  required='Please enter the 6-digit code'
                  disabled={inProcess}
                />
                <Form.Field.ValidationErrors />
              </Form.Field>
            </Form.Row>

            <Form.Actions layout='centered'>
              <Form.Button
                size='regular'
                disabled={inProcess}
                loading={inProcess}
              >
                Next
              </Form.Button>
            </Form.Actions>

            <Form.Actions layout='centered' className='vs-u-margin-top'>
              {resendTimer > 0 ? (
                <Text size='small' className='login__otp-verification-resend-text'>
                  Didn't get the code? Resend in {resendTimer}s
                </Text>
              ) : (
                <Button
                  fill='none'
                  size='regular'
                  colorVariant='brand'
                  onClick={onResendOTP}
                  disabled={inProcess}
                  className='vs-u-font-s'
                >
                  Didn't get the code? Resend now
                </Button>
              )}
            </Form.Actions>

            <Form.Actions layout='centered' className='vs-u-margin-top-double'>
              <Button
                fill='none'
                size='regular'
                icon={<Arrow direction='left' />}
                iconSide='left'
                colorVariant='brand'
                onClick={onBack}
              >
                go back
              </Button>
            </Form.Actions>
          </Form>
        </Page.Panel.Section>
      </EntryViewWrapper>
    )
  }
}

export default OTPVerification
